module.exports = __webpack_public_path__ + "static/media/restaurant.f1ad6115.png";